import { createContext, useContext } from 'react';

export type TooltipTimezone = { zone: string; label: string };

export type TimestampDisplayContextValue = {
  displayZone?: string;
  tooltipTimezones?: TooltipTimezone[];
};

const TimestampDisplayContext = createContext<TimestampDisplayContextValue | null>(null);

export function useTimestampDisplayContext(): TimestampDisplayContextValue | null {
  return useContext(TimestampDisplayContext);
}

export { TimestampDisplayContext };
